import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { changeCompany, NewAccountLinkData } from '../api'
import { usePortalMutation } from 'src/Libs/api'

interface UseChangeCompanyParams {
  onSuccess?: (vars: ChangeCompanyVariables) => void
  onError?: (vars: ChangeCompanyVariables) => void
}

interface ChangeCompanyVariables {
  installationId: number
  accountLinkId: number
  payload: NewAccountLinkData
}

type UseChangeCompanyReturnType = (data: UseChangeCompanyParams) => UseMutationResult<void | null, unknown, ChangeCompanyVariables>

/**
 * Hook to change the company account link for a specific installation
 */
export const useChangeCompany: UseChangeCompanyReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation({
    mutationFn: ({ installationId, accountLinkId, payload }) => changeCompany({ authFetch, data: payload, installationId, accountLinkId }),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })
}
